// extracted by mini-css-extract-plugin
module.exports = {"CoverImage":"CoverImage_CoverImage__1Gghe"};